import { supabase } from '../supabaseClient';

export async function deleteEmptyLegacyPlot(plotId) {
  if (!plotId) throw new Error('Selecione um talhão válido.');

  const { data, error } = await supabase.rpc('excluir_talhao_vazio_usuario', {
    p_talhao_id: plotId,
  });
  if (error) throw error;
  if (data?.excluido !== true || data?.historico_preservado !== true) {
    throw new Error('O banco não confirmou a exclusão segura do talhão.');
  }
  return data;
}
